module.exports = __webpack_public_path__ + "roboto-latin-500italic.db4a2a231f52e497c0191e8966b0ee58.woff2";